// @flow
import React from 'react';

export const HIGHLIGHT_EXPERIMENTS_ALL = '__ALL__';
export const HIGHLIGHT_EXPERIMENTS_NONE = '__NONE__';

export type DebugContextType = {|
  canEnableDebugger: boolean,

  setDebuggerVisible: (visible: boolean) => void,
  debuggerVisible: boolean,

  setDebuggingEnabled: (enabled: boolean) => void,
  debuggingEnabled: boolean,

  highlightedExperiment: string,
  highlightExperiment: (name: string) => void,

  overriddenExperiments: {
    [name: string]: string,
  },
  overrideExperiment: (name: string, group: ?string) => void,

  visibleExperimentCounts: { [name: string]: number },
  setExperimentVisible: (name: string, visible: boolean) => void,
|};

// Create a default context that satisfies the type requirements, although these
// methods and values are not expected to be used. Instead, when the
// DebugConnector is in the DOM hierarchy, it will provide this context with its
// own state.
const defaultContext: DebugContextType = {
  canEnableDebugger: false,

  setDebuggerVisible: () => {},
  debuggerVisible: false,

  setDebuggingEnabled: () => {},
  debuggingEnabled: false,

  highlightExperiment: (name: string) => {},
  highlightedExperiment: HIGHLIGHT_EXPERIMENTS_NONE,

  overrideExperiment: (name: string, group: ?string) => {},
  overriddenExperiments: {},

  visibleExperimentCounts: {},
  setExperimentVisible: (name: string, visible: boolean) => {},
};

// $FlowFixMe: new errors found from flow 0.96 upgrade
const DebugContext = React.createContext(defaultContext);
export default DebugContext;
